/* eslint-disable */
import * as Types from '../../../../../models/schema.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetProjectByIdVariablesDTO = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetProjectByIdDTO = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', id: string, title: string }> };


export const GetProjectByIdDocumentDTO = gql`
    query getProjectById($id: String!) {
  projects(filter: {id: {equals: $id}}) {
    id
    title
  }
}
    `;

/**
 * __useGetProjectById__
 *
 * To run a query within a React component, call `useGetProjectById` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectById` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectById({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectById(baseOptions: Apollo.QueryHookOptions<GetProjectByIdDTO, GetProjectByIdVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectByIdDTO, GetProjectByIdVariablesDTO>(GetProjectByIdDocumentDTO, options);
      }
export function useGetProjectByIdLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectByIdDTO, GetProjectByIdVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectByIdDTO, GetProjectByIdVariablesDTO>(GetProjectByIdDocumentDTO, options);
        }
export type GetProjectByIdHookResult = ReturnType<typeof useGetProjectById>;
export type GetProjectByIdLazyQueryDTOHookResult = ReturnType<typeof useGetProjectByIdLazyQueryDTO>;
export type GetProjectByIdQueryResultDTO = Apollo.QueryResult<GetProjectByIdDTO, GetProjectByIdVariablesDTO>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BackgroundJob": [
      "DeleteUserResourceAccessesFromPastSchoolyearsBackgroundJob",
      "DeleteUsersWithoutUserResourceAccessesBackgroundJob",
      "ImportSchoolOnboardingsBackgroundJob",
      "ImportShopItemOrderBundleSheetsBackgroundJob",
      "SyncModuleRegistrationsBackgroundJob"
    ],
    "BingoCampaignAction": [
      "ManualBingoCampaignAction",
      "ManualMeasurementBingoCampaignAction",
      "ModuleRegistrationBingoCampaignAction",
      "PupilCreditsBingoCampaignAction",
      "QuizBingoCampaignAction"
    ],
    "BingoCampaignReward": [
      "GameEnergyBingoCampaignReward",
      "PupilCreditsBingoCampaignReward"
    ],
    "Campaign": [
      "BingoCampaign",
      "VideoCampaign"
    ],
    "SearchItem": [
      "CampaignSearchItem",
      "ChallengeSearchItem",
      "ClassSearchItem",
      "ContentItemSearchItem",
      "DeviceSearchItem",
      "ExerciseSearchItem",
      "ModuleSearchItem",
      "ProjectSearchItem",
      "PupilSearchItem",
      "QuizSearchItem",
      "RegimeSearchItem",
      "RewardSearchItem",
      "SchoolSearchItem",
      "SchoolyearSearchItem",
      "ShopItemSearchItem",
      "UserSearchItem"
    ]
  }
};
      export default result;
    